import {Component, Input} from '@angular/core';
import {Events, NavController, NavParams} from "ionic-angular";
import {BookingServiceProvider} from "../../providers/booking-service/booking-service";

/**
 * Generated class for the StaffAdvancedBookingsComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
    selector: 'staff-advanced-bookings',
    templateUrl: 'staff-advanced-bookings.html'
})
export class StaffAdvancedBookingsComponent {
    @Input() barber: any;
    @Input() currencySymbol: any;
    @Input() isFromQueue :boolean = false;

    todayIds: any;

    constructor(
        public navCtrl: NavController,
        public  navParams: NavParams,
        public events: Events,
        public bookingService: BookingServiceProvider
    ) {
        this.todayIds = [];

        events.subscribe('booking:cancelledByStaff', (barber) => {
            this.barber = barber;

            this.upcomingAdvancedBookingIds().then((ids) => {
                this.todayIds = ids;
            });
        })
    }

    ngOnInit() {

    }

    ngOnChanges(changes) {
        if (changes.barber) {
            this.barber = changes.barber.currentValue;
            this.upcomingAdvancedBookingIds().then((ids) => {
                this.todayIds = ids;
            });
        }
    }

    upcomingAdvancedBookingIds() {
        return new Promise((resolve, reject) => {
            if (this.barber.todays_upcoming_advanced_bookings) {
                let ids = this.barber.todays_upcoming_advanced_bookings.map(obj => {
                    return obj.booking_id;
                });

                resolve(ids);
            }

            reject(false);
        });
    }
}



// WEBPACK FOOTER //
// ./src/components/staff-advanced-bookings/staff-advanced-bookings.ts